import { rutinInfos } from '../../_Common/Const/RutinInfo';
import notImplemented from '../../_Common/Components/notImplemented/notImplemented';
import { withAddStartedRoutine } from '../../../StartPanel/Components/Cards/StartedRoutines/startedRoutineQueries';
import { createListRutin } from '../../_Common/Components/ListRutin/ListRutin';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';
import { IRoutine, ShowDetailsRight } from '../../_Common/Const/Delsystem';
import { TestRutin2CustomAdd } from '../ObjektVyer/TestRutin2/TestRutin2CustomAdd';
import OversiktRapporterAddButton from '../ObjektVyer/OversiktRapporter/Components/OversiktRapporterAddButton';

const SYSRutiner: { [rtnKey: string]: IRoutine } = {
  rtnUsers: {
    component: getStandardRutin(rutinInfos.rtnUsers, 'SYSUser'),
    detaljVy: 'User',
  },
  rtnRoller: {
    component: getStandardRutin(rutinInfos.rtnRoller, 'SYSRoll'),
  },
  rtnArbetsstalle: {
    component: getStandardRutin(rutinInfos.rtnArbetsstalle, 'SYSArbetsstalle'),
  },
  rtnUsersMall: {
    component: getStandardRutin(rutinInfos.rtnUsersMall, 'SYSUser'), // Samma som rtnUsers
  },
  rtnKonteringskod: {
    component: getStandardRutin(
      rutinInfos.rtnKonteringskod,
      'SYSKonteringskod'
    ),
  },
  rtnValuta: {
    component: getStandardRutin(rutinInfos.rtnValuta, 'SYSValuta'),
    directEditMode: true,
  },
  rtnMoms: {
    component: getStandardRutin(rutinInfos.rtnMoms, 'SYSMoms'),
    detaljVy: 'myView',
    config: {
      SYSMoms: {
        defaultColumns: [
          { attributeDef: 'BENAMNING', caption: '', header: true },
          { attributeDef: 'MOMS_SATS1', caption: 'Moms1', header: true },
          { attributeDef: 'MOMS_SATS2', caption: 'Moms2', header: true },
        ],
      },
    },
    defaultShowDetailsRight: ShowDetailsRight.Disabled,
  },
  rtnBank: {
    component: getStandardRutin(rutinInfos.rtnBank, 'SYSBank'),
  },
  rtnSIEMottagningsvag: {
    component: getStandardRutin(
      rutinInfos.rtnSIEMottagningsvag,
      'SYSSIEMottagningsvag'
    ),
  },
  rtnFakturamottagningsvag: {
    component: getStandardRutin(
      rutinInfos.rtnFakturamottagningsvag,
      'LRFakturamottagningsvag'
    ),
  },
  rtnOrdermottagningsvag: {
    component: getStandardRutin(
      rutinInfos.rtnOrdermottagningsvag,
      'SYSOrdermottagningsvag'
    ),
  },
  rtnUtbetalningsvag: {
    component: getStandardRutin(
      rutinInfos.rtnUtbetalningsvag,
      'SYSUtbetalningsvag'
    ),
  },
  rtnLeveransvillkor: {
    component: getStandardRutin(
      rutinInfos.rtnLeveransvillkor,
      'SYSLeveransvillkor'
    ),
  },
  rtnFakturakoder: {
    component: getStandardRutin(rutinInfos.rtnFakturakoder, 'SYSFakturakod'),
  },
  rtnFakturaformedlare: {
    component: getStandardRutin(
      rutinInfos.rtnFakturaformedlare,
      'SYSFakturaformedlare'
    ),
  },
  rtnBetalningssatt: {
    component: getStandardRutin(
      rutinInfos.rtnBetalningssatt,
      'SYSBetalningssatt'
    ),
  },
  rtnInbetalningsvag: {
    component: getStandardRutin(
      rutinInfos.rtnInbetalningsvag,
      'KRInbetalningsvag'
    ),
  },
  rtnBetalningsvillkor: {
    component: getStandardRutin(
      rutinInfos.rtnBetalningsvillkor,
      'SYSBetalningsvillkor'
    ),
  },
  rtnKravrutin: {
    component: getStandardRutin(rutinInfos.rtnKravrutin, 'SYSKravrutin'),
  },
  rtnRanteTabell: {
    component: getStandardRutin(rutinInfos.rtnRanteTabell, 'SYSRanteTabell'),
  },
  rtnAutogiromall: {
    component: getStandardRutin(rutinInfos.rtnAutogiromall, 'SYSAutogiroMall'),
  },
  rtnFakturalayout: {
    component: getStandardRutin(
      rutinInfos.rtnFakturalayout,
      'SYSFakturalayout'
    ),
  },
  rtnRapportLayout: {
    component: withAddStartedRoutine(rutinInfos.rtnRapportLayout)(
      createListRutin(
        'SYSFakturalayout',
        [
          { attributeDef: 'BENAMNING', caption: 'Namn' },
          { attributeDef: 'UTSKRIFTSTYP', caption: 'Utskriftstyp' },
        ],
        notImplemented('Brevlayout DetailComp')
      )
    ),
  },
  rtnLand: {
    component: getStandardRutin(rutinInfos.rtnLand, 'SYSLand'),
  },
  rtnSprak: {
    component: getStandardRutin(rutinInfos.rtnSprak, 'SYSSprak'),
  },
  rtnTitlar: {
    component: getStandardRutin(rutinInfos.rtnTitlar, 'SYSTitel'),
  },
  rtnJobb: {
    component: getStandardRutin(rutinInfos.rtnJobb, 'SYSJobb'),
  },
  rtnDemo1: {
    component: getStandardRutin(rutinInfos.rtnDemo1, 'LRLeverantor'),
    detaljVy: 'demoRutin1Vy',
    directEditMode: true,
    config: {
      LRLeverantor: {
        attributes: {
          'OrgPers.Adress.KompaktAdressRad': {
            optionalLabel: true,
          },
          KUNDNR: {
            optionalLabel: true,
          },
        },
      },
    },
  },
  rtnTest1: {
    component: getStandardRutin(rutinInfos.rtnTest1, 'LRLeverantor'),
    detaljVy: 'testRutin1Vy',
    directEditMode: false,
    config: {
      LRLeverantor: {
        attributes: {
          'OrgPers.Adress.KompaktAdressRad': {
            optionalLabel: true,
          },
          KUNDNR: {
            optionalLabel: true,
          },
        },
      },
    },
  },
  rtnTest2: {
    component: getStandardRutin(rutinInfos.rtnTest2, 'LRLeverantor'),
    detaljVy: 'testRutin2Vy',
    directEditMode: false,
    customAddButton: TestRutin2CustomAdd,
    config: {
      LRLeverantor: {
        attributes: {
          'OrgPers.Adress.KompaktAdressRad': {
            optionalLabel: true,
          },
          KUNDNR: {
            optionalLabel: true,
          },
        },
      },
    },
  },
  rtnTest3: {
    component: getStandardRutin(rutinInfos.rtnTest3, 'EKBokforderRad'),
    directEditMode: true,
  },
  rtnVisaRapporter: {
    customAddButton: OversiktRapporterAddButton,
    component: getStandardRutin(rutinInfos.rtnVisaRapporter, 'SYSReportNew'),
    detaljVy: 'OversiktRapporter',
    directEditMode: true,
    initialUrval: 'sLkTmRpICLaGGgIuvuKIbbvFYSOTHxXx', // PDF-Rapporter
  },
};

export default SYSRutiner;
